import type { Variants } from "framer-motion";

export const motionTiming = {
  quick: 0.18,
  normal: 0.32,
};

export const ease = {
  standard: [0.22, 1, 0.36, 1],
} as const;

export const detailReveal: Variants = {
  hidden: { opacity: 0, y: 8 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: motionTiming.normal,
      ease: ease.standard,
    },
  },
};

export const cardContentVariants: Variants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.07,
      delayChildren: 0.08,
    },
  },
};

export const stageVariants: Variants = {
  initial: { opacity: 0, y: 10 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: motionTiming.normal,
      ease: ease.standard,
    },
  },
  exit: {
    opacity: 0,
    y: -10,
    transition: {
      duration: motionTiming.quick,
      ease: ease.standard,
    },
  },
};
